import {Component, forwardRef, input, output, viewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {SimpleOption} from '@app/shared/model/simple-option';
import {MessageTranslateService} from '@app/shared/services/i18n/translate-service-service.service';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {RuleState} from '@app/shared/services/api/tickets/tickets.interface';
import {CollectionUtils} from '@app/shared/util/collections/collection-utils';
import {AppConstants} from '@shared/util/app-constants';


const options: SimpleOption<RuleState, I18nMessage>[] = [
  {value: RuleState.RUNNING, label: {messageKey: 'Running'}},
  {value: RuleState.PAUSED, label: {messageKey: 'Stopped'}},
  {value: RuleState.DELETED, label: {messageKey: 'Deleted'}}
];

export const messageByRuleStateOption = CollectionUtils.indexBy(options, 'value', option => option.label);

@Component({
  selector: 'app-rule-state-select',
  templateUrl: './rule-state-select.component.html',
  standalone: false,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RuleStateSelectComponent), multi: true}
  ]
})
export class RuleStateSelectComponent implements ControlValueAccessor {
  options: SimpleOption<RuleState>[];
  readonly valueKey: keyof SimpleOption = 'value';
  readonly labelKey: keyof SimpleOption = 'label';
  readonly DROPDOWN_HOLDER_SELECTOR = AppConstants.DROPDOWN_HOLDER_SELECTOR;

  maxSelectedLabels = input(1);
  placeholder = input<string | null>(null);
  multiSelect = input(true);
  openEvent = output<any>();
  closeEvent = output<any>();
  aceSelect = viewChild.required(AceSelectComponent);

  constructor(translateService: MessageTranslateService) {
    this.options = options.map(option => ({...option, label: translateService.instant(option.label)}));
  }

  writeValue(value: RuleState[] | RuleState): void {
    this.aceSelect().writeValue(value);
  }

  registerOnChange(fn: (value: RuleState[] | RuleState) => void): void {
    this.aceSelect().registerOnChange(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.aceSelect().registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.aceSelect().setDisabledState(isDisabled);
  }

  onOpenEvent(event: any): void {
    this.openEvent.emit(event);
  }

  onCloseEvent(event: any): void {
    this.closeEvent.emit(event);
  }
}
